export const GET_FOLDERS = "GET_FOLDERS";
export const GET_FOLDERS_REQUEST = "GET_FOLDERS_REQUEST";
export const GET_FOLDERS_FAILURE = "GET_FOLDERS_FAILURE";
export const SEND_CONTENT_REQUEST = "SEND_CONTENT_REQUEST";
export const SEND_CONTENT_FAILURE = "SEND_CONTENT_SUCCESS";
export const SEND_CONTENT_SUCCESS = "SEND_CONTENT_FAILURE";
export const RESET_SENT_DATA = "RESET_SENT_DATA";
